// extracted by mini-css-extract-plugin
module.exports = {"theme":"#F39910"};